
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { useAsync } from 'react-async-hook';

export const useUserEmail = () => {
  const { user } = useAuthenticator(ctx => [ctx.user]);

  const { result: email, loading, error } = useAsync(async () => {
    if (!user) return null;
    
    const session = await fetchAuthSession({ forceRefresh: true });
    const email =  session.tokens?.idToken?.payload?.email;
    if (typeof email === 'string') {
      return email;
    }
    return null;
  }, [user?.username]);

  return { email, loading, error };
};